import React from 'react'

const About = () => {
  return (
    <section className="section about-section">
      <h1 className="section-title">about us</h1>
      <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Est dignissimos at commodi ducimus necessitatibus nemo voluptatum suscipit deserunt perferendis sapiente, repellendus obcaecati a dicta ipsum nihil qui minus itaque nam.</p>
    </section>
  )
}

export default About